import * as React from "react";
import { changeRocFilter } from "../../containers/Map.action";
import classNames from "classnames";
import "./Filter.scss";
import { MapContext } from "../../containers/Map.context";

const Filter = (props: React.PropsWithChildren<any>) => {
	const { dispatch, state: mapState } = React.useContext(MapContext);

	const branchClasses = classNames({
		btn: true,
		"btn-default": mapState.regionalOperationCenter,
		"btn-primary text-white": !mapState.regionalOperationCenter,
	});

	const rocClasses = classNames({
		btn: true,
		"btn-default": !mapState.regionalOperationCenter,
		"btn-primary text-white": mapState.regionalOperationCenter,
	});

	const branchHandler = (event: React.SyntheticEvent<EventTarget>): void => {
		const action = changeRocFilter(false);
		dispatch(action);
	};

	const rocHandler = (event: React.SyntheticEvent<EventTarget>): void => {
		const action = changeRocFilter(true);
		dispatch(action);
	};

	return (
		<div className="location-filter w-25 card mt-3 mb-1">
			<div className=" text-center">Filter:</div>
			<div className="filter-buttons list-group-horizonal">
				<button className={branchClasses} onClick={branchHandler}>
					Branches
				</button>
				<button className={rocClasses} onClick={rocHandler}>
					Regional Operation Centers
				</button>
			</div>
		</div>
	);
};

export default Filter;
